<lib-not-modal
  [title]="'CLIENT.CABINET.HELP.CONTACTS_MODAL_TITLE'"
  [width]="'min(100dvw - 32px, 480px)'"
>
  <lib-cabinet-help-contacts [contacts]="contacts" [hideSectionTitle]="true" />
</lib-not-modal>
